__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "crunchorder";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@crunchit/http-client", "1.3.3", () => (__webpack_require__.e(496).then(() => (() => (__webpack_require__(72496))))));
			register("@emotion/react", "11.11.3", () => (Promise.all([__webpack_require__.e(513), __webpack_require__.e(914), __webpack_require__.e(774)]).then(() => (() => (__webpack_require__(54774))))));
			register("@emotion/styled", "11.11.0", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(371), __webpack_require__.e(903)]).then(() => (() => (__webpack_require__(45903))))));
			register("@mui/material", "5.15.10", () => (Promise.all([__webpack_require__.e(923), __webpack_require__.e(566), __webpack_require__.e(827), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(371), __webpack_require__.e(118), __webpack_require__.e(517)]).then(() => (() => (__webpack_require__(62566))))));
			register("@mui/system", "5.15.9", () => (Promise.all([__webpack_require__.e(923), __webpack_require__.e(513), __webpack_require__.e(476), __webpack_require__.e(914), __webpack_require__.e(371), __webpack_require__.e(118), __webpack_require__.e(703)]).then(() => (() => (__webpack_require__(20476))))));
			register("file-saver", "2.0.5", () => (__webpack_require__.e(450).then(() => (() => (__webpack_require__(72450))))));
			register("jwt-decode", "3.1.2", () => (__webpack_require__.e(70).then(() => (() => (__webpack_require__(87070))))));
			register("moment", "2.30.1", () => (__webpack_require__.e(178).then(() => (() => (__webpack_require__(86178))))));
			register("oidc-client", "1.11.5", () => (__webpack_require__.e(958).then(() => (() => (__webpack_require__(66958))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(97950))))));
			register("react-i18next", "14.0.5", () => (Promise.all([__webpack_require__.e(117), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(74117))))));
			register("react-quill", "2.0.0", () => (Promise.all([__webpack_require__.e(823), __webpack_require__.e(914), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(92823))))));
			register("react-redux", "7.2.9", () => (Promise.all([__webpack_require__.e(508), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(716)]).then(() => (() => (__webpack_require__(97508))))));
			register("react-router-dom", "6.22.1", () => (Promise.all([__webpack_require__.e(245), __webpack_require__.e(914), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(53245))))));
			register("react-sortablejs", "6.1.4", () => (Promise.all([__webpack_require__.e(786), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(15786))))));
			register("react", "18.2.0", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(65043))))));
			register("redux-thunk", "2.4.2", () => (__webpack_require__.e(708).then(() => (() => (__webpack_require__(63708))))));
			register("redux", "4.2.1", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(16096))))));
			register("xlsx", "0.18.5", () => (__webpack_require__.e(238).then(() => (() => (__webpack_require__(11238))))));
			initExternal(77791);
			initExternal(47266);
			initExternal(21500);
			initExternal(29272);
			initExternal(93672);
			initExternal(90272);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};